import { Injectable } from '@angular/core';

@Injectable()
export class RecipeCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello");
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe/recipe.common.ts